<template>
  <div class="zu-tips-wrap" :style="newStyle">
    <i :class="[icon, 'zu-tips-icon']" v-if="showIcon"></i>
    <span class="zu-tips-text">
      <slot>{{ value }}</slot>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: String, default: '' },
    icon: { type: String, default: 'el-icon-warning' },
    showIcon: { type: Boolean, default: false },
    size: { type: String, default: '' },
    color: { type: String, default: '' },
    bgColor: { type: String, default: '' },
    type: { type: String, default: 'info' },
    customStyle: { type: Object, default: () => ({}) }
  },
  data() {
    return {

    }
  },
  computed: {
    newStyle() {
      const arr = {
        green: {
          color: '#4AD999',
          backgroundColor: '#E5F9ED'
        },
        orange: {
          color: '#F9660D',
          backgroundColor: '#FAEEE8'
        },
        red: {
          color: '#F25858',
          backgroundColor: '#FFEAEA'
        },
        info: {
          color: '#909399',
          backgroundColor: '#f4f4f5'
        }
      }
      const obj1 = arr[this.type] || {}
      const obj2 = { }
      if (this.size) obj2.fontSize = this.size
      if (this.color) obj2.color = this.color
      if (this.bgColor) obj2.backgroundColor = this.bgColor
      return { ...this.customStyle, ...obj1, ...obj2 }
    }
  }
}
</script>

<style lang="scss" scoped>
.zu-tips {
  &-wrap {
    display: inline-block;
    padding: 5rem 10rem;
    border-radius: 6rem;
    background-color: #f4f4f5;
    color: #909399;
    font-size: 12rem;
    line-height: 20rem;
    &:not(:last-child) {
      margin-right: 10rem;
    }
  }
  &-icon {
    margin-right: 4rem;
  }
  &-text {
  }
  &-success {
    color: #67c23a;
    background-color: #f0f9eb;
  }
  &-warning {
    color: #e6a23c;
    background-color: #fdf6ec;
  }
  &-danger {
  }
}

</style>
